import { useEffect, useState } from 'react';
export function useIsReady(options) {
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    // If we've already updated the ready state, don't do it again
    if (isReady) {
      return;
    }
    if (typeof options.isReady === 'undefined') {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      return setIsReady(true);
    }
    if (typeof options.isReady === 'function') {
      setIsReady(options.isReady());
    } else if (options.isReady) {
      setIsReady(true);
    }
  }, [options, isReady]);
  return isReady;
}